/**
 * Toggle Hamburger/Close icon
 */
class Hamburger {
    constuctor() {}

    init() {
        this.hamburgers = document.querySelectorAll('.hamburger')
        if (this.hamburgers.length > 0) {
            this.hamburgers.forEach((hamburger) => {
                hamburger.addEventListener(
                    'click',
                    () => {
                        hamburger.classList.toggle('is-active')
                    },
                    false
                )
            })
        }
    }
}

export default new Hamburger() // return singleton instance
